import { UsersAppNirvanaDataProvider } from '../dataProvider/UsersAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class UsersAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, UsersAppNirvanaDataProvider);
  }
}
